import actions from './actions'

export default function SepaRechnungsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_SEPARECHNUNG:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_SEPARECHNUNG:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_SEPARECHNUNG:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_SEPARECHNUNG:
      return {
        ...state,
        editing: { sepaRechnungID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_SEPARECHNUNG_RECIEVED ||
      actions.UPDATE_SEPARECHNUNG_RECIEVED ||
      actions.DELETE_SEPARECHNUNG_RECIEVED:
      return {
        ...state,
        editing: { sepaRechnungID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
